import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalChoiceComponent } from '../modal-choice/modal-choice.component';
import { MatDialog } from '@angular/material/dialog';
import { AppHttpService } from 'src/app/app-http.service';
import { Subscriber, Observable } from 'rxjs';
import { ModalMensageComponent } from '../modal-mensage/modal-mensage.component';
import { text } from "../../../../config/text";

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.css']
})
export class RecoveryComponent implements OnInit {

  constructor(private router: Router, public dialog: MatDialog, public http: AppHttpService) { }

  id: string = "";
  document: string = "";
  date: string = "";
  datemask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  documentRequired: boolean = localStorage['CampoDocumentoObrigatorio'] == undefined ? true : localStorage['CampoDocumentoObrigatorio'];
  msg :string = "";
  ngOnInit(): void {
    this.http.autenticar();
	
	const getParameterByName = function(url: string, name: string){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
    if (results==null) {
		return null;
		}
		return decodeURI(results[1]) || 0;
	};
	
	var myParam = getParameterByName(window.location.search, 'uid');
	if (myParam != null)
	{
		this.http.getValidatePasswordToken(myParam.toString()).subscribe((data: any) => {
		localStorage['userId'] = data.id;
		this.router.navigate(['newpassword']);
		}, ((error: any) => {
		console.log(error)
		const dialogRef = this.dialog.open(ModalMensageComponent,
			{
			data: {
				msg: error.error[0].message
			}
			});
		}));
	}
  } 
	
  backUrl(){
    window.location.assign(localStorage['URL_BACK']);
  }

  openDialog() {
    let d = this.date.split("/");
    let dateUax = d[2] + '-' + d[1] + '-' + d[0];
    this.http.getEmailpass(this.id, this.document, dateUax).subscribe((data: any) => {
      const dialogRef = this.dialog.open(ModalChoiceComponent,
        {

          data: {
            email: data.email,
            phone: data.phoneNumber,
			formaEnvio: data.formaEnvioNuevaContrasena,
			formaEnvioDigitoVerificador: data.formaEnvioDigitoVerificador
          }
        });

      localStorage["email"] = data.email;
      localStorage["phoneNumber"] = data.phoneNumber;
	  localStorage["formaEnvio"] = data.formaEnvioNuevaContrasena;
	  localStorage["formaEnvioDigitoVerificador"] = data.formaEnvioDigitoVerificador;
      localStorage['userId'] = this.id;

    }, ((error: any) => {
      console.log(error)

      this.msg=  text.dados_invalidos;

      if (error.error.length > 0) {
        if( error.error[0].message == 'La persona no tiene email' && error.error[1].message=='La persona no tiene número de telefono' ){
          this.msg = text.erroEmailTelefone;
        }
		else
		if( error.error[0].message == 'La persona no tiene email' && error.error[1].message=='La persona no tiene email' ){
          this.msg = text.erroEmail;
        }	
		else
		if( error.error[0].message == 'La persona no tiene número de telefono' && error.error[1].message=='La persona no tiene número de telefono' ){
          this.msg = text.erroTelefone;
        }	
        else
        if(error.error.length > 1 && error.error[0].message == 'MensagemValidacao'){
          this.msg = error.error[1].message;
        }
      }

      const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg:  this.msg
          }
        });

    }));
  }
}




